

var _squid = require('squid');

require('./directive');

require('./addbank/route');

require('./sepa/route');

(function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
})(window.angular);

angular.module().factory('$AddBankFlowRoute', function () {

    return _squid.$ComponentRoute.extend('BankRoute', {
        name: 'bank',
        directive: 'xo-add-bank-flow',
        titleContent: 'asideHeader.addBank',
        children: [{
            name: '$XOAddBankRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                'error-message': 'errorMessage',
                bank: 'bank',
                sidebar: 'sidebar',
                hideparenthead: 'hideparenthead',
                'page-level': 'pageLevel',
                'show-set-preferred-fi': 'showSetPreferredFi',
                'show-cancel': 'showCancel'
            }
        }, {
            name: '$XOSepaRoute',
            attributes: {
                token: 'token',
                'parent-callbacks': 'callbacks',
                model: 'bank',
                sidebar: 'sidebar',
                hideparenthead: 'hideparenthead'
            }
        }]
    });
});

_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-bank/route.js
// module id = ../node_modules/xo-wallet-components/src/add-bank/route.js
// module chunks = 0